import _AbstractMaterialData from "./implementation/material/AbstractMaterialData";
import _AnimationData from "./implementation/data/AnimationData";
import _GeometryData from "./implementation/data/GeometryData";
import _BoneData from "./implementation/data/BoneData";
import _types from "./types";
import _CustomData from "./implementation/data/CustomData";
import _IGumballParameterSettings from "./interfaces/parameter/IGumballParameterSettings";
import _HTMLElementAnchorData from "./implementation/data/HTMLElementAnchorData";
import _IGeometryData from "./interfaces/data/IGeometryData";
import _IInteractionParameterSettings from "./interfaces/parameter/IInteractionParameterSettings";
import _IMapData from "./interfaces/data/material/IMapData";
import _IMaterialAbstractData from "./interfaces/data/material/IMaterialAbstractData";
import _ISelectionParameterSettings from "./interfaces/parameter/ISelectionParameterSettings";
import _ITaskEvent from "./interfaces/events/ITaskEvent";
import _MapData from "./implementation/material/MapData";
import _MaterialBasicLineData from "./implementation/material/MaterialBasicLineData";
import _MaterialGemData from "./implementation/material/MaterialGemData";
import _MaterialMultiPointData from "./implementation/material/MaterialMultiPointData";
import _MaterialPointData from "./implementation/material/MaterialPointData";
import _MaterialShadowData from "./implementation/material/MaterialShadowData";
import _MaterialSpecularGlossinessData from "./implementation/material/MaterialSpecularGlossinessData";
import _MaterialUnlitData from "./implementation/material/MaterialUnlitData";
import _MaterialVariantsData from "./implementation/material/MaterialVariantsData";
import _SDTFAttributesData from "./implementation/sdtf/SDTFAttributesData";
import _SDTFItemData from "./implementation/sdtf/SDTFItemData";
import _SDTFOverviewData from "./implementation/sdtf/SDTFOverviewData";
import * as _sdk2 from "@shapediver/sdk.sdtf-primitives";
var _sdk = _sdk2;
try {
  if ("default" in _sdk2) _sdk = _sdk2.default;
} catch (e) {}
import * as _sdk4 from "@shapediver/sdk.sdtf-v1";
var _sdk3 = _sdk4;
try {
  if ("default" in _sdk4) _sdk3 = _sdk4.default;
} catch (e) {}
import _MaterialStandardData from "./implementation/material/MaterialStandardData";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateGumballParameterSettings = exports.IGumballParameterJsonSchema = exports.isInteractionGumballParameterSettings = exports.validateSelectionParameterSettings = exports.ISelectionParameterJsonSchema = exports.isInteractionSelectionParameterSettings = exports.validateInteractionParameterSettings = exports.IInteractionParameterJsonSchema = exports.PARAMETER_VISUALIZATION = exports.PARAMETER_TYPE = exports.SdtfPrimitiveTypeGuard = exports.SDTF_TYPEHINT = exports.SDTFItemData = exports.SDTFAttributeData = exports.SDTFAttributesData = exports.SDTFOverviewData = exports.TASK_TYPE = exports.BoneData = exports.CustomData = exports.HTMLElementAnchorData = exports.HTMLElementAnchorImageData = exports.HTMLElementAnchorTextData = exports.HTMLElementAnchorCustomData = exports.PRIMITIVE_MODE = exports.MaterialVariantsData = exports.PrimitiveData = exports.AttributeData = exports.GeometryData = exports.AnimationData = exports.TEXTURE_FILTERING = exports.TEXTURE_WRAPPING = exports.MATERIAL_TYPE = exports.MATERIAL_SHADING = exports.MATERIAL_ALPHA = exports.MATERIAL_SIDE = exports.MapData = exports.MaterialBasicLineData = exports.MaterialMultiPointData = exports.MaterialPointData = exports.MaterialGemData = exports.MaterialSpecularGlossinessData = exports.MaterialShadowData = exports.MaterialUnlitData = exports.AbstractMaterialData = exports.MaterialStandardData = void 0;
const AbstractMaterialData_1 = _AbstractMaterialData;
Object.defineProperty(exports, "AbstractMaterialData", {
  enumerable: true,
  get: function () {
    return AbstractMaterialData_1.AbstractMaterialData;
  }
});
const AnimationData_1 = _AnimationData;
Object.defineProperty(exports, "AnimationData", {
  enumerable: true,
  get: function () {
    return AnimationData_1.AnimationData;
  }
});
const GeometryData_1 = _GeometryData;
Object.defineProperty(exports, "AttributeData", {
  enumerable: true,
  get: function () {
    return GeometryData_1.AttributeData;
  }
});
Object.defineProperty(exports, "GeometryData", {
  enumerable: true,
  get: function () {
    return GeometryData_1.GeometryData;
  }
});
Object.defineProperty(exports, "PrimitiveData", {
  enumerable: true,
  get: function () {
    return GeometryData_1.PrimitiveData;
  }
});
const BoneData_1 = _BoneData;
Object.defineProperty(exports, "BoneData", {
  enumerable: true,
  get: function () {
    return BoneData_1.BoneData;
  }
});
const types_1 = _types;
Object.defineProperty(exports, "PARAMETER_TYPE", {
  enumerable: true,
  get: function () {
    return types_1.PARAMETER_TYPE;
  }
});
Object.defineProperty(exports, "PARAMETER_VISUALIZATION", {
  enumerable: true,
  get: function () {
    return types_1.PARAMETER_VISUALIZATION;
  }
});
const CustomData_1 = _CustomData;
Object.defineProperty(exports, "CustomData", {
  enumerable: true,
  get: function () {
    return CustomData_1.CustomData;
  }
});
const IGumballParameterSettings_1 = _IGumballParameterSettings;
Object.defineProperty(exports, "isInteractionGumballParameterSettings", {
  enumerable: true,
  get: function () {
    return IGumballParameterSettings_1.isInteractionGumballParameterSettings;
  }
});
const HTMLElementAnchorData_1 = _HTMLElementAnchorData;
Object.defineProperty(exports, "HTMLElementAnchorCustomData", {
  enumerable: true,
  get: function () {
    return HTMLElementAnchorData_1.HTMLElementAnchorCustomData;
  }
});
Object.defineProperty(exports, "HTMLElementAnchorData", {
  enumerable: true,
  get: function () {
    return HTMLElementAnchorData_1.HTMLElementAnchorData;
  }
});
Object.defineProperty(exports, "HTMLElementAnchorImageData", {
  enumerable: true,
  get: function () {
    return HTMLElementAnchorData_1.HTMLElementAnchorImageData;
  }
});
Object.defineProperty(exports, "HTMLElementAnchorTextData", {
  enumerable: true,
  get: function () {
    return HTMLElementAnchorData_1.HTMLElementAnchorTextData;
  }
});
const IGeometryData_1 = _IGeometryData;
Object.defineProperty(exports, "PRIMITIVE_MODE", {
  enumerable: true,
  get: function () {
    return IGeometryData_1.PRIMITIVE_MODE;
  }
});
const IInteractionParameterSettings_1 = _IInteractionParameterSettings;
Object.defineProperty(exports, "IGumballParameterJsonSchema", {
  enumerable: true,
  get: function () {
    return IInteractionParameterSettings_1.IGumballParameterJsonSchema;
  }
});
Object.defineProperty(exports, "IInteractionParameterJsonSchema", {
  enumerable: true,
  get: function () {
    return IInteractionParameterSettings_1.IInteractionParameterJsonSchema;
  }
});
Object.defineProperty(exports, "ISelectionParameterJsonSchema", {
  enumerable: true,
  get: function () {
    return IInteractionParameterSettings_1.ISelectionParameterJsonSchema;
  }
});
Object.defineProperty(exports, "validateGumballParameterSettings", {
  enumerable: true,
  get: function () {
    return IInteractionParameterSettings_1.validateGumballParameterSettings;
  }
});
Object.defineProperty(exports, "validateInteractionParameterSettings", {
  enumerable: true,
  get: function () {
    return IInteractionParameterSettings_1.validateInteractionParameterSettings;
  }
});
Object.defineProperty(exports, "validateSelectionParameterSettings", {
  enumerable: true,
  get: function () {
    return IInteractionParameterSettings_1.validateSelectionParameterSettings;
  }
});
const IMapData_1 = _IMapData;
Object.defineProperty(exports, "TEXTURE_FILTERING", {
  enumerable: true,
  get: function () {
    return IMapData_1.TEXTURE_FILTERING;
  }
});
Object.defineProperty(exports, "TEXTURE_WRAPPING", {
  enumerable: true,
  get: function () {
    return IMapData_1.TEXTURE_WRAPPING;
  }
});
const IMaterialAbstractData_1 = _IMaterialAbstractData;
Object.defineProperty(exports, "MATERIAL_ALPHA", {
  enumerable: true,
  get: function () {
    return IMaterialAbstractData_1.MATERIAL_ALPHA;
  }
});
Object.defineProperty(exports, "MATERIAL_SHADING", {
  enumerable: true,
  get: function () {
    return IMaterialAbstractData_1.MATERIAL_SHADING;
  }
});
Object.defineProperty(exports, "MATERIAL_SIDE", {
  enumerable: true,
  get: function () {
    return IMaterialAbstractData_1.MATERIAL_SIDE;
  }
});
Object.defineProperty(exports, "MATERIAL_TYPE", {
  enumerable: true,
  get: function () {
    return IMaterialAbstractData_1.MATERIAL_TYPE;
  }
});
const ISelectionParameterSettings_1 = _ISelectionParameterSettings;
Object.defineProperty(exports, "isInteractionSelectionParameterSettings", {
  enumerable: true,
  get: function () {
    return ISelectionParameterSettings_1.isInteractionSelectionParameterSettings;
  }
});
const ITaskEvent_1 = _ITaskEvent;
Object.defineProperty(exports, "TASK_TYPE", {
  enumerable: true,
  get: function () {
    return ITaskEvent_1.TASK_TYPE;
  }
});
const MapData_1 = _MapData;
Object.defineProperty(exports, "MapData", {
  enumerable: true,
  get: function () {
    return MapData_1.MapData;
  }
});
const MaterialBasicLineData_1 = _MaterialBasicLineData;
Object.defineProperty(exports, "MaterialBasicLineData", {
  enumerable: true,
  get: function () {
    return MaterialBasicLineData_1.MaterialBasicLineData;
  }
});
const MaterialGemData_1 = _MaterialGemData;
Object.defineProperty(exports, "MaterialGemData", {
  enumerable: true,
  get: function () {
    return MaterialGemData_1.MaterialGemData;
  }
});
const MaterialMultiPointData_1 = _MaterialMultiPointData;
Object.defineProperty(exports, "MaterialMultiPointData", {
  enumerable: true,
  get: function () {
    return MaterialMultiPointData_1.MaterialMultiPointData;
  }
});
const MaterialPointData_1 = _MaterialPointData;
Object.defineProperty(exports, "MaterialPointData", {
  enumerable: true,
  get: function () {
    return MaterialPointData_1.MaterialPointData;
  }
});
const MaterialShadowData_1 = _MaterialShadowData;
Object.defineProperty(exports, "MaterialShadowData", {
  enumerable: true,
  get: function () {
    return MaterialShadowData_1.MaterialShadowData;
  }
});
const MaterialSpecularGlossinessData_1 = _MaterialSpecularGlossinessData;
Object.defineProperty(exports, "MaterialSpecularGlossinessData", {
  enumerable: true,
  get: function () {
    return MaterialSpecularGlossinessData_1.MaterialSpecularGlossinessData;
  }
});
const MaterialUnlitData_1 = _MaterialUnlitData;
Object.defineProperty(exports, "MaterialUnlitData", {
  enumerable: true,
  get: function () {
    return MaterialUnlitData_1.MaterialUnlitData;
  }
});
const MaterialVariantsData_1 = _MaterialVariantsData;
Object.defineProperty(exports, "MaterialVariantsData", {
  enumerable: true,
  get: function () {
    return MaterialVariantsData_1.MaterialVariantsData;
  }
});
const SDTFAttributesData_1 = _SDTFAttributesData;
Object.defineProperty(exports, "SDTFAttributeData", {
  enumerable: true,
  get: function () {
    return SDTFAttributesData_1.SDTFAttributeData;
  }
});
Object.defineProperty(exports, "SDTFAttributesData", {
  enumerable: true,
  get: function () {
    return SDTFAttributesData_1.SDTFAttributesData;
  }
});
const SDTFItemData_1 = _SDTFItemData;
Object.defineProperty(exports, "SDTFItemData", {
  enumerable: true,
  get: function () {
    return SDTFItemData_1.SDTFItemData;
  }
});
const SDTFOverviewData_1 = _SDTFOverviewData;
Object.defineProperty(exports, "SDTFOverviewData", {
  enumerable: true,
  get: function () {
    return SDTFOverviewData_1.SDTFOverviewData;
  }
});
const sdk_sdtf_primitives_1 = _sdk;
Object.defineProperty(exports, "SdtfPrimitiveTypeGuard", {
  enumerable: true,
  get: function () {
    return sdk_sdtf_primitives_1.SdtfPrimitiveTypeGuard;
  }
});
const sdk_sdtf_v1_1 = _sdk3;
Object.defineProperty(exports, "SDTF_TYPEHINT", {
  enumerable: true,
  get: function () {
    return sdk_sdtf_v1_1.SdtfTypeHintName;
  }
});
const MaterialStandardData_1 = _MaterialStandardData;
Object.defineProperty(exports, "MaterialStandardData", {
  enumerable: true,
  get: function () {
    return MaterialStandardData_1.MaterialStandardData;
  }
});
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  validateGumballParameterSettings = exports.validateGumballParameterSettings,
  IGumballParameterJsonSchema = exports.IGumballParameterJsonSchema,
  isInteractionGumballParameterSettings = exports.isInteractionGumballParameterSettings,
  validateSelectionParameterSettings = exports.validateSelectionParameterSettings,
  ISelectionParameterJsonSchema = exports.ISelectionParameterJsonSchema,
  isInteractionSelectionParameterSettings = exports.isInteractionSelectionParameterSettings,
  validateInteractionParameterSettings = exports.validateInteractionParameterSettings,
  IInteractionParameterJsonSchema = exports.IInteractionParameterJsonSchema,
  PARAMETER_VISUALIZATION = exports.PARAMETER_VISUALIZATION,
  PARAMETER_TYPE = exports.PARAMETER_TYPE,
  SdtfPrimitiveTypeGuard = exports.SdtfPrimitiveTypeGuard,
  SDTF_TYPEHINT = exports.SDTF_TYPEHINT,
  SDTFItemData = exports.SDTFItemData,
  SDTFAttributeData = exports.SDTFAttributeData,
  SDTFAttributesData = exports.SDTFAttributesData,
  SDTFOverviewData = exports.SDTFOverviewData,
  TASK_TYPE = exports.TASK_TYPE,
  BoneData = exports.BoneData,
  CustomData = exports.CustomData,
  HTMLElementAnchorData = exports.HTMLElementAnchorData,
  HTMLElementAnchorImageData = exports.HTMLElementAnchorImageData,
  HTMLElementAnchorTextData = exports.HTMLElementAnchorTextData,
  HTMLElementAnchorCustomData = exports.HTMLElementAnchorCustomData,
  PRIMITIVE_MODE = exports.PRIMITIVE_MODE,
  MaterialVariantsData = exports.MaterialVariantsData,
  PrimitiveData = exports.PrimitiveData,
  AttributeData = exports.AttributeData,
  GeometryData = exports.GeometryData,
  AnimationData = exports.AnimationData,
  TEXTURE_FILTERING = exports.TEXTURE_FILTERING,
  TEXTURE_WRAPPING = exports.TEXTURE_WRAPPING,
  MATERIAL_TYPE = exports.MATERIAL_TYPE,
  MATERIAL_SHADING = exports.MATERIAL_SHADING,
  MATERIAL_ALPHA = exports.MATERIAL_ALPHA,
  MATERIAL_SIDE = exports.MATERIAL_SIDE,
  MapData = exports.MapData,
  MaterialBasicLineData = exports.MaterialBasicLineData,
  MaterialMultiPointData = exports.MaterialMultiPointData,
  MaterialPointData = exports.MaterialPointData,
  MaterialGemData = exports.MaterialGemData,
  MaterialSpecularGlossinessData = exports.MaterialSpecularGlossinessData,
  MaterialShadowData = exports.MaterialShadowData,
  MaterialUnlitData = exports.MaterialUnlitData,
  AbstractMaterialData = exports.AbstractMaterialData,
  MaterialStandardData = exports.MaterialStandardData;